"use client";

import Link from "next/link";
import { Truck } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useListingBrowseContext } from "@/components/listing/browse/context/listing-browse-context";
import { useHeroMapContext } from "@/components/home/context/HeroMapContext";
import { facetQueryFor } from "@/lib/listings/category-facets";

export function buildTruckloadHref(
  productSlug: string,
  conditions: readonly string[],
  specFilters: ReadonlyArray<{ field: string; value: string }>,
  quantity: number,
): string {
  const params = new URLSearchParams();
  if (quantity > 1) params.set("qty", String(quantity));
  if (conditions.length > 0) params.set("grade", conditions.join(","));
  for (const filter of specFilters) {
    for (const [key, value] of new URLSearchParams(facetQueryFor(filter.field, filter.value))) {
      params.set(key, value);
    }
  }
  const query = params.toString();
  return `/listing/category/${productSlug}/build${query ? `?${query}` : ""}`;
}

export function PriceTruckloadLink({ productSlug }: { productSlug: string }) {
  const { conditions, specFilters } = useListingBrowseContext();
  const { quantity } = useHeroMapContext();
  return (
    <Button asChild variant="primary" size="compact">
      <Link href={buildTruckloadHref(productSlug, conditions, specFilters, quantity ?? 1)}>
        <Truck />
        Price a truckload
      </Link>
    </Button>
  );
}
